export interface AnalysisRanges {
  peakRangeFrom: number | null;
  peakRangeTo: number | null;
  residualRangeFrom: number | null;
  residualRangeTo: number | null;
}

export interface AnalysisData extends AnalysisRanges {
  peakShearStress: number | null;
  peakNormalStress: number | null;
  peakHorizontalDisp: number | null;
  peakFrictionAngle: number | null;
  residualShearStress: number | null;
  residualNormalStress: number | null;
  residualHorizontalDisp: number | null;
  residualFrictionAngle: number | null;
  peakVerticalDisp: number | null;
  peakDilationAngle: number | null;
  residualDilationAngle: number | null;
  /** Per-stage dilation averaging window (mm) this stage was last calculated
   *  with (BUG-2026-0211). null → fall back to the test-level value. */
  dilationRange: number | null;
}

export const EMPTY_ANALYSIS: AnalysisData = {
  peakRangeFrom: null,
  peakRangeTo: null,
  residualRangeFrom: null,
  residualRangeTo: null,
  peakShearStress: null,
  peakNormalStress: null,
  peakHorizontalDisp: null,
  peakFrictionAngle: null,
  residualShearStress: null,
  residualNormalStress: null,
  residualHorizontalDisp: null,
  residualFrictionAngle: null,
  peakVerticalDisp: null,
  peakDilationAngle: null,
  residualDilationAngle: null,
  dilationRange: null,
};
